import { css, Interpolation, Theme } from '@emotion/react'
import { useEffect, useState } from 'react'
import Select, { ActionMeta, SingleValue } from 'react-select'

type Props = {
  initialValue?: number
  isSearchable?: boolean
  isClearable?: boolean
  isError?: boolean
  addStyle?: Interpolation<Theme>
  onChange?: (
    newValue: SingleValue<{ label: string; value: number }>,
    actionMeta: ActionMeta<{ label: string; value: number }>,
  ) => void
}

const style = css`
  width: 25rem;
`
const roleData = [
  { name: '管理者', role: 1 , isDisabled: false},
  { name: '承認者', role: 2 , isDisabled: true},
  { name: '一般', role: 3 , isDisabled: false},
]
// TODO : roleのデータをAPIから取得するようにする。anyを使わないようにする。
export const RoleSelect = ({
  onChange,
  isSearchable,
  initialValue,
  isClearable,
  isError = false,
  addStyle,
}: Props) => {
  const [options, setOptions] = useState<
    { label: string; value: number; isDisabled?: boolean }[]
  >([])
  const [value, setValue] =
    useState<SingleValue<{ label: string; value: number; isDisabled?: boolean }>>(
      null,
    )

  useEffect(() => {
    const newOptions = roleData.map((type: any) => ({
      label: type.name,
      value: type.role,
      isDisabled: type.isDisabled,
    }))
    setOptions(newOptions)

    const initialOption = newOptions.find(
      (opt: any) => opt.value === initialValue,
    )
    setValue(initialOption || null)
  }, [initialValue])

  const handleChange = (
    newValue: SingleValue<{ label: string; value: number; isDisabled?: boolean }>,
    actionMeta: ActionMeta<{ label: string; value: number }>,
  ) => {
    setValue(newValue)
    // newValueからisDisabledを除外してonChangeに渡す
    const valueWithoutDisabled = newValue
      ? { label: newValue.label, value: newValue.value }
      : null
    onChange?.(valueWithoutDisabled, actionMeta)
  }

  return (
    <Select
      css={[style, addStyle]}
      isSearchable={isSearchable}
      value={value}
      placeholder="権限を選択"
      name="role"
      options={options}
      onChange={handleChange}
      isClearable={isClearable}
      styles={{
        control: (provided) => ({
          ...provided,
          height: '26px',
          minHeight: '26px',
          fontSize: '14px',
          borderColor: isError ? '#FF0000' : provided.borderColor,
          '&:hover': {
            borderColor: isError ? '#FF0000' : provided.borderColor,
          },
        }),
        valueContainer: (provided) => ({
          ...provided,
          height: '26px',
          padding: '0 8px',
        }),
        input: (provided) => ({
          ...provided,
          margin: '0',
          padding: '0',
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          height: '26px',
        }),
      }}
    />
  )
}
